import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '~/hooks';
import { RoutesEnum } from '~/constants/enums';
import { ValuationRoutesEnum } from '~/constants/enums/valuationEnums';
import { PREFIX_ROUTE } from '~/constants';
import { WalletRoutesEnum } from '~/constants/enums/walletEnums';

export default function useFullRoutes() {
  const { i18n } = useTranslation('app');
  const locale = i18n.language;
  const { mobileScreen } = useBreakpoint();
  return {
    ROOT_URL: `/${locale}/${PREFIX_ROUTE}/`,
    MY_ACCOUNT_URL: {
      ROOT: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}`,
      DETAILS: mobileScreen
        ? `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.DETAILS}`
        : `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}`,
      UPDATE_NAME: mobileScreen
        ? `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.DETAILS}/${RoutesEnum.UPDATE_NAME}`
        : `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.UPDATE_NAME}`,
      UPDATE_EMAIL: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.SETTINGS_AND_PRIVACY}/${RoutesEnum.UPDATE_EMAIL}`,
      UPDATE_PASSWORD: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.SETTINGS_AND_PRIVACY}/${RoutesEnum.UPDATE_PASSWORD}`,
      UPDATE_PHONE: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.SETTINGS_AND_PRIVACY}/${RoutesEnum.UPDATE_PHONE_NUMBER}`,
      SETTINGS_AND_PRIVACY: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.SETTINGS_AND_PRIVACY}`,
      COMPANY_INFO: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.COMPANY_INFO}`,
      UPDATE_COMPANY: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.COMPANY_INFO}/${RoutesEnum.UPDATE}`,
      MANAGE_CONTACTS: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.MANAGE_CONTACT}`,
      PERSONAL_INFO: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.PERSONAL_INFO}`,
      UPDATE_PERSONAL_INFO: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.PERSONAL_INFO}/${RoutesEnum.UPDATE}`,
      USER_SUBSCRIPTION: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.USER_SUBSCRIPTION}`,
      USER_CARDS: {
        ROOT: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.USER_CARDS}`,
        ADD_CARD: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${RoutesEnum.USER_CARDS}/${RoutesEnum.USER_ADD_CARD}`,
      },
      WALLET: {
        ROOT: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${WalletRoutesEnum.WALLET}`,
        TOPUP: (amount: number) =>
          `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_ACCOUNT}/${WalletRoutesEnum.TOPUP}?amount=${amount}`,
      },
    },
    SUBSCRIPTION_URL: {
      ROOT: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.SUBSCRIPTION}`,
      CHECKOUT: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.SUBSCRIPTION}/${id}/checkout`,
    },
    PACKAGES_URL: {
      ROOT: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.PACKAGES}`,
      CHECKOUT: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.PACKAGES}/${id}/checkout`,
    },
    AQAR_CONNECT_URL: {
      ROOT: `/${RoutesEnum.AQAR_CONNECT}`,
      CHECKOUT: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.AQAR_CONNECT_SEGMENT}/${id}/checkout`,
    },
    ADD_LISTING_URL: {
      INITIALIZE: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${RoutesEnum.INITIALIZE}`,
      DETAILS: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}/${RoutesEnum.DETAILS}`,
      EDIT: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}/${RoutesEnum.EDIT}`,
      PHOTOS: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}/${RoutesEnum.PHOTOS}`,
      PUBLISH: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}/${RoutesEnum.PUBLISH}`,
      CHECKOUT: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}/${RoutesEnum.CHECKOUT}`,
      PRICE: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}/${RoutesEnum.PRICE}`,
      FEATURE: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}/${RoutesEnum.FEATURE}`,
      FEATURE_CHECKOUT: (id: string | number, featureKey: string) =>
        `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.MY_LISTING}/${id}/${RoutesEnum.FEATURE}/${featureKey}/${RoutesEnum.CHECKOUT}`,
    },
    VALUATION_URL: {
      ROOT: `/${locale}/${PREFIX_ROUTE}/${ValuationRoutesEnum.VALUATION}`,
      ADD: `/${locale}/${PREFIX_ROUTE}/${ValuationRoutesEnum.VALUATION}/${ValuationRoutesEnum.ADD}`,
      MY_VALUATIONS: `/${locale}/${PREFIX_ROUTE}/${ValuationRoutesEnum.VALUATION}/${ValuationRoutesEnum.MY_VALUATIONS}`,
      RESULTS: (id: string | number) =>
        `/${locale}/${PREFIX_ROUTE}/${ValuationRoutesEnum.VALUATION}/${id}`,
    },
    ACTIVITIES_URL: {
      ROOT: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.ACTIVITIES}`,
      FAVORITES: `/${locale}/${PREFIX_ROUTE}/${RoutesEnum.ACTIVITIES}/${RoutesEnum.FAVORITES}`,
    },
  };
}
